import { Component, computed, inject, input } from '@angular/core';
import { NumberSuffixPipe } from '@core/pipes/number-suffix.pipe';
import { EPlatform } from '@enums/campaign.enum';
import { TranslateService } from '@ngx-translate/core';
import { IconComponent } from '@shared/components/icon/icon.component';
import { camelCase } from 'lodash';

@Component({
  imports: [IconComponent, NumberSuffixPipe],
  selector: 'app-kpi-card',
  templateUrl: './kpi-card.component.html',
})
export class KpiCardComponent {
  public readonly current = input<number | null>(null);
  public readonly unit = input<string | null>(null);
  public readonly platforms = input<EPlatform[] | null>(null);
  public readonly total = input<number | null>(null);

  public readonly label = input<string>('');
  public readonly labelKey = input<string>('');
  public readonly labelIcon = input<string>('');

  public readonly padding = input<string>('24px');
  public readonly backgroundColor = input<string>('var(--shikenso-pink-100)');
  public readonly currentFontSize = input<string>('36px');
  public readonly totalFontSize = input<string>('36px');
  public readonly labelFontSize = input<string>('18px');

  public readonly calculatedLabel = computed(() =>
    this.labelKeyFormatted()
      ? this.translate.instant(`components.kpiCard.names.${this.labelKeyFormatted()}`)
      : this.label(),
  );
  public readonly calculatedLabelIcon = computed(() => this.labelIcon() || this.iconMap[this.labelKeyFormatted()]);

  public readonly labelKeyFormatted = computed(() => camelCase(this.labelKey()));

  private readonly translate = inject(TranslateService);

  private readonly iconMap: Record<string, string> = {
    activeCampaigns: '/icons/campaigns.svg',
    activeCreators: '/icons/creators.svg',
    activeCustomers: '/icons/customers.svg',
    avgCampaignsPerCreator: '/icons/campaigns.svg',
    avgCampaignsPerCustomer: '/icons/campaigns.svg',
    avgChannelsPerCreator: '/icons/library.svg',
    avgCreatorsPerCustomer: '/icons/creators.svg',
    concurrentCampaigns: '/icons/campaigns.svg',
    creatorChannels: '/icons/library.svg',
    involvedCreators: '/icons/creators.svg',
    involvedCustomers: '/icons/customers.svg',
    newCustomers: '/icons/customers.svg',
  };
}
